export default "__VITE_ASSET__d5db6446__"